import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "details-stack" }

import AppSelectField from "@/shared/components/ui/AppSelectField.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ClassificationForm',
  props: {
    business_type: { default: "" },
    service_category: { default: "" },
    businessTypeOptions: { default: () => [] },
    serviceCategoryOptions: { default: () => [] },
    errors: { default: () => ({}) }
  },
  emits: [
  "update:business_type",
  "update:service_category",
],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(AppSelectField, {
                "model-value": __props.business_type,
                items: __props.businessTypeOptions,
                "item-title": "label",
                "item-value": "value",
                label: "Business Type",
                "label-icon": "mdi-briefcase-outline",
                placeholder: "Select business type",
                "error-messages": __props.errors.business_type ? [__props.errors.business_type] : [],
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:business_type', String($event || ''))))
              }, null, 8, ["model-value", "items", "error-messages"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(AppSelectField, {
                "model-value": __props.service_category,
                items: __props.serviceCategoryOptions,
                "item-title": "label",
                "item-value": "value",
                label: "Service Category",
                "label-icon": "mdi-shape-outline",
                placeholder: "Select service category",
                "error-messages": __props.errors.service_category ? [__props.errors.service_category] : [],
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:service_category', String($event || ''))))
              }, null, 8, ["model-value", "items", "error-messages"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})